import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'
import useViewport from '../../modules/viewport/useViewport'

import { SurveyMode } from '../../actions/types'

import style from './style.module.scss'

export interface INavigationPanelTimeProps {
  mode: SurveyMode
  progressTotal: number
  progressCurrent: number
  progressQuestionTime: number
}

const NavigationPanelTime = React.memo<INavigationPanelTimeProps>(
  ({ mode, progressTotal, progressCurrent, progressQuestionTime }) => {
    const secondsLeft = Math.max(0, progressTotal - progressCurrent)

    const { mobile } = useViewport()
    const { t } = useInterfaceLocale()

    let timeStr = ''
    switch (mode) {
      case SurveyMode.XRAYS: {
        timeStr =
          0 < progressQuestionTime
            ? `${
                mobile ? t('navigation', 'time', 'xrays', 'mobile') : t('navigation', 'time', 'xrays', 'desktop')
              } ${formatSeconds(progressQuestionTime)}`
            : ''
        break
      }
      default: {
        if (0 === secondsLeft) {
          timeStr = ''
        } else {
          timeStr =
            secondsLeft > Math.min(progressTotal * 0.2, 60)
              ? `~ ${formatSeconds(secondsLeft)}`
              : t('navigation', 'time', 'almostThere')
        }
        break
      }
    }

    return (
      <span className={style.NavigationPanelContentTime} data-testid="SW-Time">
        {timeStr}
      </span>
    )
  },
  (prevProps, nextProps) =>
    prevProps.mode === nextProps.mode &&
    prevProps.progressTotal === nextProps.progressTotal &&
    prevProps.progressCurrent === nextProps.progressCurrent &&
    prevProps.progressQuestionTime === nextProps.progressQuestionTime
)

NavigationPanelTime.displayName = 'NavigationPanelTime'

export default NavigationPanelTime

function formatSeconds(seconds: number) {
  const secondsInt = Math.round(seconds)
  const h = Math.floor(secondsInt / 3600)
  const m = Math.floor((secondsInt - h * 3600) / 60)
  const s = secondsInt - h * 3600 - m * 60

  return `${0 < h ? `${h}:` : ''}${10 > m ? `0${m}` : m}:${10 > s ? `0${s}` : s}`
}
